<template>
    <form class="contact-form form">

        <label v-if="texts.nameLabel" class="form__label" for="contact-form__name" id="contact-form__name-label">{{ t('nameLabel') }}</label>
        <input class="form__input" type="text" id="contact-form__name" name="name" :disabled="isInputDisabled" :placeholder="t('namePlaceholder', '')" v-model="contactName" />

        <label v-if="texts.emailLabel" for="contact-form__email" id="contact-form__email-label" :class="emailLabelClass">{{ t('emailLabel') }}</label>
        <input :class="['form__input', emailLabelClass]" type="email" id="contact-form__email" name="email" :disabled="isInputDisabled" :placeholder="t('emailPlaceholder', '')" v-model="contactEmail" />

        <label v-if="texts.phoneLabel" for="contact-form__phone" id="contact-form__phone-label" class="form__label">{{ t('phoneLabel') }}</label>
        <input class="form__input" type="text" id="contact-form__phone" name="phone" :disabled="isInputDisabled" :placeholder="t('phonePlaceholder', '')" v-model="contactPhone" />

        <label v-if="texts.topicLabel" class="form__label" for="contact-form__topic" id="contact-form__topic-label">{{ t('topicLabel') }}</label>
        <div class="select-input" id="contact-form__topic-select" :disabled="isInputDisabled">

            <slot name="select-icon" />

            <select :class="['form__select', {'form__select-invalid': !contactSubject }]" name="topic" id="contact-form__topic" v-model="contactSubject" :disabled="isInputDisabled">
                <option v-if="texts.topicPlaceholder" value="" disabled selected hidden> {{ t('topicPlaceholder') }}</option>
                <option v-for="topic in topics" :key="topic">{{ topic }}</option>
            </select>
        </div>

        <label v-if="texts.messageLabel" class="form__label" for="contact-form__message" id="contact-form__message-label">{{ t('messageLabel') }}</label>
        <textarea class="form__textarea" name="message" id="contact-form__message" :disabled="isInputDisabled" :placeholder="t('messagePlaceholder', '')" v-model="contactMessage"></textarea>

        <div class="form__checkbox-label" id="contact-form__disclaimer">
            <input class="form__checkbox" type="checkbox" id="contact-form__disclaimer-checkbox" :disabled="isInputDisabled" v-model="contactDisclaimer" />
            <label class="text" for="contact-form__disclaimer-checkbox" v-html="t('disclaimerLabel')" />
        </div>

        <div v-if="success && !error" class="form__response-message form__success">
            <p>{{ t('formSuccessMessage') }}</p>
        </div>

        <div v-if="success && error" class="form__response-message form__error ">
            <p>{{ t(error) }}</p>
        </div>


        <levelx-button v-if="!success || error" id="contact-submit-button" @click.prevent="handleSubmit" variant="outlined" style="primary" :loading="loading" :disabled="isButtonDisabled" icon-position="right">
            <template #loading-indicator><slot name="loading-icon" /></template>
            {{ t('submitButtonLabel') }}
        </levelx-button>

    </form>
</template>

<script>
import { emailIsValid } from '@/utils/EmailValidator.js';

export default {
    name: 'ContactForm',

    props: {
        texts: Object,
        topics: Array,
    },

    data() {
        return {
            contactName: '',
            contactEmail: '',
            contactPhone: '',
            contactSubject: '',
            contactMessage: '',
            contactDisclaimer: false,

            success: false,
            loading: false,
            error: null,
        }
    },

    created() {
        // this.contactSubject = this.topics[0] ?? null;
    },

    computed: {

        isButtonDisabled() {
            return !this.contactName || !this.contactEmail || this.emailInvalid || !this.contactSubject || !this.contactMessage || !this.contactDisclaimer;
        },

        isInputDisabled() {
            return this.loading || this.success && !this.error;
        },

        emailInvalid() {
            return !!this.contactEmail.trim().length && !emailIsValid(this.contactEmail);
        },

        emailLabelClass() {
            return {
                'form__input--invalid': this.contactEmail.length > 0 && !emailIsValid(this.contactEmail)
            }
        },

        topicOptions() {
            return this.topics.map(topic => ({ text: topic.text, value: topic.text }));
        }
    },


    methods: {
        async handleSubmit() {

            if (this.isButtonDisabled) { return; }

            this.error = null;
            this.success = false;
            this.loading = true;

            var bodyFormData = new FormData();
            bodyFormData.set('payload', JSON.stringify({
                name: this.contactName,
                email: this.contactEmail,
                phone: this.contactPhone,
                subject: this.contactSubject,
                message: this.contactMessage,
                disclaimer: this.contactDisclaimer
            }));

            const { data } = await this.$axios.post('/actions/site-module/contact-form/submit', bodyFormData);

            // const data = {
            //     // error: 'errorFormFieldRequired',
            //     success: true
            // };

            if (data.hasOwnProperty('error')) {
                this.error = data.error;
            }

            this.loading = false;
            this.success = true;
        },

        t(key, fallback) {
            if (!this.texts || !this.texts.hasOwnProperty(key)) {
                return fallback != null ? fallback : key;
            }

            return this.texts[key];
        },
    },
}
</script>
